export default function TravelAndParkingCommon ({ }) {
  return <span />
}
